import { hasMatchIntent, resolveMatchIntent } from "./resolveMatchIntent";

export function buildSearchFitIntent({
  query = "",
  category = null,
  categoryId = null,
  aiSession = null,
  user = null,
} = {}) {
  const { wizardAnswers } = resolveMatchIntent({ aiSession, user });
  const trimmedQuery = String(query || "").trim();
  const context = {
    ...(trimmedQuery ? { query: trimmedQuery } : {}),
    ...(category && category !== "All" ? { category } : {}),
    ...(categoryId ? { categoryId } : {}),
  };

  if (hasMatchIntent(wizardAnswers)) {
    return { ...wizardAnswers, ...context };
  }
  if (user && (trimmedQuery || Object.keys(context).length > 0)) {
    return Object.keys(context).length > 0 ? context : null;
  }
  if (trimmedQuery) {
    return { query: trimmedQuery };
  }
  return null;
}

export function buildBrowseFitIntent({
  categoryName = null,
  aiSession = null,
  user = null,
} = {}) {
  const { wizardAnswers } = resolveMatchIntent({ aiSession, user });
  const base = categoryName
    ? { category: categoryName, type: categoryName }
    : {};

  if (hasMatchIntent(wizardAnswers)) {
    return { ...wizardAnswers, ...base };
  }
  return null;
}

export function shouldShowGridMatchScores(intentParams) {
  return intentParams != null && typeof intentParams === "object";
}
